var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSsynp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.3109 8.14209L7.15625 16.3021H25.2897L16.3109 24.4621",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2254 11.1646C17.8945 11.1646 19.2476 9.81146 19.2476 8.14234C19.2476 6.47322 17.8945 5.12012 16.2254 5.12012C14.5562 5.12012 13.2031 6.47322 13.2031 8.14234C13.2031 9.81146 14.5562 11.1646 16.2254 11.1646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2254 11.1646C17.8945 11.1646 19.2476 9.81146 19.2476 8.14234C19.2476 6.47322 17.8945 5.12012 16.2254 5.12012C14.5562 5.12012 13.2031 6.47322 13.2031 8.14234C13.2031 9.81146 14.5562 11.1646 16.2254 11.1646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15504 19.022C8.82416 19.022 10.1773 17.6689 10.1773 15.9998C10.1773 14.3306 8.82416 12.9775 7.15504 12.9775C5.48592 12.9775 4.13281 14.3306 4.13281 15.9998C4.13281 17.6689 5.48592 19.022 7.15504 19.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15504 19.022C8.82416 19.022 10.1773 17.6689 10.1773 15.9998C10.1773 14.3306 8.82416 12.9775 7.15504 12.9775C5.48592 12.9775 4.13281 14.3306 4.13281 15.9998C4.13281 17.6689 5.48592 19.022 7.15504 19.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2254 26.8799C17.8945 26.8799 19.2476 25.5268 19.2476 23.8577C19.2476 22.1886 17.8945 20.8354 16.2254 20.8354C14.5562 20.8354 13.2031 22.1886 13.2031 23.8577C13.2031 25.5268 14.5562 26.8799 16.2254 26.8799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2254 26.8799C17.8945 26.8799 19.2476 25.5268 19.2476 23.8577C19.2476 22.1886 17.8945 20.8354 16.2254 20.8354C14.5562 20.8354 13.2031 22.1886 13.2031 23.8577C13.2031 25.5268 14.5562 26.8799 16.2254 26.8799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6863 19.022C26.3554 19.022 27.7085 17.6689 27.7085 15.9998C27.7085 14.3306 26.3554 12.9775 24.6863 12.9775C23.0172 12.9775 21.6641 14.3306 21.6641 15.9998C21.6641 17.6689 23.0172 19.022 24.6863 19.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6863 19.022C26.3554 19.022 27.7085 17.6689 27.7085 15.9998C27.7085 14.3306 26.3554 12.9775 24.6863 12.9775C23.0172 12.9775 21.6641 14.3306 21.6641 15.9998C21.6641 17.6689 23.0172 19.022 24.6863 19.022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_2486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsynp);
export default __webpack_public_path__ + "static/media/ssynp.b9a87c35a2fd15bbe4554ecbda8bfacc.svg";
export { ForwardRef as ReactComponent };